/**
 * @module app.cm
 */

import { autoinject, bindingMode } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { IPopup } from 'app/shared/elements/popup-base';
import * as CM from 'app/cm/models/essette-api';


@autoinject()
export class ProgramsDisplayModal extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.array({ defaultBindingMode: bindingMode.oneTime })
    protected programGroups: ReadonlyArray<CM.ProgramGroup> = [];

    protected selectedProgramId: string | null = null;

    ////****************** Element References ***************************************////
    protected $modal!: IPopup;


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
    }


    ////****************** Functions ************************************************////
    public open(selectedProgramId: string | null = null): void {
        this.selectedProgramId = selectedProgramId;
        this.$modal.open();
    }
}
